import { useLaboratory } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  id?: string
  onClose: () => void
}

export const RemoveLaboratory = ({ onClose, id }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { deleteLaboratory } = useLaboratory()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteLaboratory(id as string)
      onClose()
      showToast('Laboratory deleted successfully')
      setIsLoading(false)
    } catch (error: any) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this test"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete Laboratory Test"
    />
  )
}
